import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Preloader from "@/components/Preloader";
import CookieBanner from "@/components/CookieBanner";
import { useScrollProgress } from "@/hooks/useReveal";
import { applyPageMeta } from "@/lib/seo";

import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeSupply from "@/pages/WhatWeSupply";
import ForContractors from "@/pages/ForContractors";
import Export from "@/pages/Export";
import Renovation from "@/pages/Renovation";
import Clients from "@/pages/Clients";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

const PageMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => { applyPageMeta(pathname); }, [pathname]);
  return null;
};

const ScrollProgress = () => {
  const pct = useScrollProgress();
  return <div className="scroll-progress" style={{ width: `${pct}%` }} data-testid="scroll-progress"/>;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <main key={location.pathname} className="page-fade">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/what-we-supply" element={<WhatWeSupply />} />
        <Route path="/for-contractors" element={<ForContractors />} />
        <Route path="/export-import" element={<Export />} />
        <Route path="/renovation-construction" element={<Renovation />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Preloader />
      <BrowserRouter>
        <ScrollToTop />
        <PageMeta />
        <ScrollProgress />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
        <FloatingActions />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
